import { InjectionToken } from '@angular/core';

/**
 * Controls whether chat comments show the "(Edited)" indicator. Bot chats stream their answer
 * through repeated edits of one comment, so their hosting view provides `false` to keep every
 * message from being marked as edited.
 */
export const IS_EDITED_INDICATOR_VISIBLE = new InjectionToken<boolean>('IS_EDITED_INDICATOR_VISIBLE', {
  factory: () => true
});
